import React from "react";
import { Page } from "../../components/page/page";
import styles from "./lineage.module.css";
import { ChooseButton } from "../../components/choose-button/choose-button";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setLineage } from "../../store/stateSlice";

const options = [
  {
    value: "Yes",
    icon: "✅",
  },
  {
    value: "I think so",
    icon: "🤔",
  },
  {
    value: "I’m not aware",
    icon: "🤷‍♀️",
  },
  {
    value: "No, I don’t have any",
    icon: "🙅‍♀️",
  },
];

const LineagePage = () => {
  const dispatch = useDispatch();
  return (
    <Page
      title="Are there known witches or intuitively powerful women in your lineage?"
      hideContinueButton={true}
      currentStep={11}
    >
      <ul className={styles.list}>
        {options.map((option, i) => (
          <li key={i}>
            <Link
              to="../witch-skill"
              onClick={() => dispatch(setLineage(option.value))}
            >
              <ChooseButton icon={option.icon}>{option.value}</ChooseButton>
            </Link>
          </li>
        ))}
      </ul>
    </Page>
  );
};

export { LineagePage };
